module.exports = __webpack_public_path__ + "static/media/Crouch End Alcoves 5.4ec84b6c.jpg";